"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = ViewCard;

var _ViewCard = require("@adobe/react-spectrum-workflow/dist/ViewCard");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function ViewCard(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_ViewCard.A4uViewCard, null));
}